export default __webpack_public_path__ + "static/media/cortina-inicio-desktop.4d5424a7.jpg";